import React from "react";

interface TicketIconProps {
  width?: number;
  height?: number;
}

const TicketIcon: React.FC<TicketIconProps> = ({ width = 20, height = 16 }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20 6V2C20 0.89 19.1 0 18 0H2C0.9 0 0.00999999 0.89 0.00999999 2V6C1.11 6 2 6.9 2 8C2 9.1 1.11 10 0 10V14C0 15.1 0.9 16 2 16H18C19.1 16 20 15.1 20 14V10C18.9 10 18 9.1 18 8C18 6.9 18.9 6 20 6ZM18 4.54C16.81 5.23 16 6.53 16 8C16 9.47 16.81 10.77 18 11.46V14H2V11.46C3.19 10.77 4 9.47 4 8C4 6.52 3.2 5.23 2.01 4.54L2 2H18V4.54ZM9 11H11V13H9V11ZM9 7H11V9H9V7ZM9 3H11V5H9V3Z"
        fill="#A41E35"
      />
    </svg>
  );
};

export default TicketIcon;
